import { useEffect, useRef } from 'react'

export const viewportHeightCssVariable = 'var(--vh, 1vh)'

export const useMobileViewportHeight = (selector = 'div#root') => {
  const previousHeight = useRef<number | undefined>(undefined)

  const setDocumentHeight = () => {
    const { innerHeight } = window

    if (innerHeight === previousHeight.current) {
      return
    }

    requestAnimationFrame(() => {
      document.querySelector<HTMLElement>(selector)?.style.setProperty('--vh', `${innerHeight / 100}px`)
      previousHeight.current = innerHeight
    })
  }

  window.addEventListener('load', setDocumentHeight)
  window.addEventListener('resize', setDocumentHeight)
  window.addEventListener('orientationchange', setDocumentHeight)

  useEffect(setDocumentHeight, [selector])

  return () => {
    window.removeEventListener('load', setDocumentHeight)
    window.removeEventListener('resize', setDocumentHeight)
    window.removeEventListener('orientationchange', setDocumentHeight)
  }
}
